import React, {useState} from "react";
import "./OnlineOrderList.scss";
import {useHistory} from "react-router-dom";

function OrderCard({item}) {
    return(
        <div className="OrderCard-container">
            <div className="OrderCard-price">
                <i className="fa fa-arrow-left"></i>
                <div className="price-rtl">
                    <span> {item.price}</span>
                    <span>ریال</span>
                </div>

            </div>
            <div className="OrderCard-info">
                <span className="uid">{item.uid}</span>
                <span className="status">{item.status}</span>
            </div>
        </div>
    )
}

function OnlineOrderList() {

    const history = useHistory();

    const data =[
        {uid:"ewrwr255",status:"پرداخت شده",price:998357},
        {uid:"345345fds",status:"پرداخت شده",price:998357},
        {uid:"4kj38945",status:"پرداخت شده",price:998357},
        {uid:"lfk4895",status:"پرداخت شده",price:998357},
    ]

    return(
        <div className="online-order-list-container">
            <div className="storeDetail-header">
                <span>لیست سفارشات</span>
                <i onClick={()=>{
                    history.push(`/store`);
                }}
                   className="fa fa-arrow-right"></i>
            </div>
            {data.map(item=>{
                return(
                    <OrderCard item={item}/>
                )
            })}
        </div>
    )
}

export {OnlineOrderList};
